import {
  notificationCTPPreferenceGroups,
  notificationCTPFrequencyOptions,
} from 'src/components/Notifications/Preferences/mock-CTP-data';
import { notificationSubscriptionFrequencyOptions } from 'src/components/Notifications/Preferences/mock-data';
import { TOKENS } from 'src/components/Notifications/unsubscribe/mock-data';

const UnsubscribeApacSavedSearchByCodePayload = {
  __resolveType: (arg0: any) => arg0.__typename,
};
const UpdateNotificationCtpPreferencesPayload = {
  __resolveType: (arg0: any) => arg0.__typename,
};
const UpdateNotificationCtpSubscriptionWithTokenPayload = {
  __resolveType: (arg0: any) => arg0.__typename,
};

const Mutation = {
  updateNotificationSubscription: (_: any, args: any) => {
    const { channelCode, productCode, subscribe, frequency } = args.input;
    return {
      __typename: 'NotificationPreference',
      subscriptions: [
        {
          __typename: 'NotificationSubscription',
          id: `${productCode}:${channelCode}`,
          subscribed: subscribe,
          frequency: frequency
            ? {
                value: frequency,
                options: notificationSubscriptionFrequencyOptions,
                __typename: 'NotificationFrequency',
              }
            : null,
        },
      ],
    };
  },
  updateNotificationCtpPreferences: (_: any, args: any) => {
    const { preferences } = args.input;
    const preferencesResult = preferences.map((preference: any) => {
      const { id: productId, notificationsChannel } = preference;

      notificationCTPPreferenceGroups.forEach((group) => {
        group.preferences.forEach((pref) => {
          if (pref.product.id === productId) {
            pref.subscriptions.forEach((sub) => {
              const newChannel = notificationsChannel.find(
                (n: any) => n.channel === sub.channel.id,
              );
              if (newChannel) {
                sub.subscribed = newChannel.subscribe;
                sub.frequency = newChannel.frequency
                  ? {
                      value: newChannel.frequency,
                      options: notificationCTPFrequencyOptions,
                      __typename: 'NotificationCTPFrequency',
                    }
                  : null;
              }
            });
          }
        });
      });

      const formattedSubscriptions = notificationsChannel.map(
        (subscription: any) => {
          const { subscribe, channel, frequency } = subscription;
          return {
            __typename: 'NotificationCTPSubscription',
            id: `${productId}:${channel}`,
            subscribed: subscribe,
            channel: {
              label: channel === 'email' ? 'Email' : 'Push Notifications',
              id: channel,
              __typename: 'NotificationCTPChannel',
            },
            frequency: frequency
              ? {
                  value: frequency,
                  options: notificationCTPFrequencyOptions,
                  __typename: 'NotificationCTPFrequency',
                }
              : null,
          };
        },
      );

      return {
        product: {
          id: productId,
        },
        subscriptions: formattedSubscriptions,
        __typename: 'NotificationCTPPreference',
      };
    });

    return {
      __typename: 'UpdateNotificationCtpPreferencesSuccess',
      success: [
        {
          __typename: 'NotificationCTPPreferenceGroup',
          preferences: preferencesResult,
        },
      ],
    };
  },
  updateNotificationSubscriptionWithToken: (_: any, args: any) => {
    const { token, subscribe } = args.input;
    if (token === TOKENS.ERROR) {
      throw new Error('503 simulated server error');
    }
    return {
      __typename: 'NotificationPreference',
      product: {
        code: 'WRU',
        label: 'Job Recommendations',
      },
      subscriptions: [
        {
          __typename: 'NotificationSubscription',
          id: `WRU:email`,
          subscribed: subscribe,
          channel: {
            code: 'email',
          },
        },
      ],
    };
  },
  updateNotificationCtpSubscriptionWithToken: (_: any, args: any) => {
    const { token, subscribe } = args.input;

    return token === TOKENS.ERROR
      ? {
          __typename: 'UpdateNotificationCtpPreferenceFailure',
          error: {
            errorCode: 404,
            message: 'Error Message',
          },
        }
      : {
          __typename: 'UpdateNotificationCtpSubscriptionWithTokenSuccess',
          product: {
            __typename: 'NotificationCTPProduct',
            id: 'WRU',
            label: 'Job Recommendations',
          },
          subscriptionChannel: {
            __typename: 'NotificationCTPChannel',
            id: 'email',
          },
          subscribed: subscribe,
        };
  },

  unsubscribeApacSavedSearchByCode: (_: any, args: any) => {
    const { code } = args.input;
    return code === TOKENS.ERROR
      ? {
          __typename: 'UnsubscribeApacSavedSearchByCodeFailure',
          error: {
            message: 'Error Message',
          },
        }
      : { __typename: 'UnsubscribeApacSavedSearchByCodeSuccess' };
  },
};

const Candidate = {
  notificationCTPPreferenceGroups: () => notificationCTPPreferenceGroups,
};

export {
  UnsubscribeApacSavedSearchByCodePayload,
  UpdateNotificationCtpPreferencesPayload,
  UpdateNotificationCtpSubscriptionWithTokenPayload,
  Mutation,
  Candidate,
};
